<script setup>
const emit = defineEmits(["selectedLink"]);

defineProps({
	meta: {
		type: Object,
		required: true
	},
	links: {
		type: Object,
		required: true
	},
	only: {
		type: Array,
		default: () => []
	},
	pageClass: String
});

function selectedLink(link) {
	if (link.url != null) {
		emit("selectedLink", link);
	}
}
</script>

<template>
	<div class="bg-color-white2 w-full">
		<div class="flex justify-between" :class="pageClass">
			<div class="text-[14px] font-normal">
				{{ " " }}
				<span class="font-medium">{{ meta.total }}</span>
				{{ " " }}
				件中
				{{ " " }}
				<span class="font-medium">{{ meta.from }}</span>
				{{ " " }}
				～
				{{ " " }}
				<span class="font-medium">{{ meta.to }}</span>
				{{ " " }}
				を表示中
			</div>

			<div>
				<nav aria-label="Pagination" class="pagination">
					<div
						v-for="(link, index) in meta.links"
						class="pagination_inner"
						:class="{
							none: !link.url,
							active: link.active,
							'': !link.active,
							pagination_prev: index === 0,
							pagination_next: index === meta.links.length - 1
						}"
						@click="selectedLink(link)"
					>
						{{ link.label }}
					</div>
				</nav>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;

.pagination {
	width: 100%;
	display: flex;
	align-items: center;
}
.pagination_text {
	font-size: 1.4rem;
}
.pagination_inner {
	font-size: 1.4rem;
	padding: 8px 15px;
	cursor: pointer;
	background: $bg-white2;
	@include boxShadow(0.1);

	@include trans(0.3);
	&:hover {
		color: $primaryColor;
		@include trans(0.3);
	}
}
.pagination_prev {
	margin-right: 10px;
	@include trans(0.3);
	border-radius: 30px 5px 5px 30px;
}
.pagination_next {
	margin-left: 10px;
	@include trans(0.3);
	border-radius: 5px 30px 30px 5px;
}
.pagination_prev:hover,
.pagination_next:hover {
	color: $color-white2;
	background: $primaryColor;
	@include trans(0.3);
}

.pagination_prev + .pagination_inner {
	border-radius: 5px 0 0 5px;
}

.pagination_inner:nth-last-child(2) {
	border-radius: 0 5px 5px 0;
}
.pagination_inner.active {
	color: $color-white2;
	padding: 12px 10px;
	border-radius: 5px;
	background: $primaryColor;
}
.pagination_inner.none {
	color: $color-gray3;
	background: $bg-white2;
}
</style>
